export default __webpack_public_path__ + "static/media/m2.6fa156c0.jpg";